<template>
  <iCallToast
    v-if="message"
    :title="title"
    :icon="icon"
    :tone="tone"
    data-test="call-state-banner"
    :data-call-phase="phase"
  >
    {{ message }}
    <template v-if="canRetry" #actions>
      <iCallToastAction data-test="call-state-retry" @click="$emit('retry')">
        Try again
      </iCallToastAction>
    </template>
  </iCallToast>
</template>

<script>
import {
  CALL_PHASE_DEGRADED,
  CALL_PHASE_ENDED,
  CALL_PHASE_ERROR,
} from "%/apps/video-engine/stores/video-call-ui-store";

export default {
  name: "CallStateBanner",
  props: {
    phase: {
      type: String,
      required: true,
    },
    errorMessage: {
      type: String,
      required: false,
      default: "",
    },
  },
  emits: ["retry"],
  computed: {
    message() {
      switch (this.phase) {
        case CALL_PHASE_DEGRADED:
          return "Video is paused to keep the audio going.";
        case CALL_PHASE_ERROR:
          return this.errorMessage || "We couldn't connect you to the call. Check your connection and try again.";
        case CALL_PHASE_ENDED:
          return "This event has ended.";
        default:
          return "";
      }
    },
    title() {
      switch (this.phase) {
        case CALL_PHASE_DEGRADED:
          return "Your connection is unstable";
        case CALL_PHASE_ERROR:
          return "You're not connected";
        default:
          return "The event has ended";
      }
    },
    icon() {
      switch (this.phase) {
        case CALL_PHASE_DEGRADED:
          return "ic:outline-signal-cellular-alt-2-bar";
        case CALL_PHASE_ERROR:
          return "ic:outline-wifi-off";
        default:
          return "ic:outline-event-busy";
      }
    },
    tone() {
      switch (this.phase) {
        case CALL_PHASE_DEGRADED:
          return "warning";
        case CALL_PHASE_ERROR:
          return "error";
        default:
          return "info";
      }
    },
    canRetry() {
      return this.phase === CALL_PHASE_ERROR;
    },
  },
};
</script>
